var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { lock: true }
        }
      ],
      staticClass: "school-info"
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "show-form",
          attrs: {
            model: _vm.showBaseForm,
            rules: _vm.showBaseFormRules,
            "label-width": "186px",
            size: "mini"
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c("el-form-item", { attrs: { label: "所属主管单位：" } }, [
                      _c("span", { staticClass: "form-show-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.showBaseForm.orgParentName !== undefined &&
                              _vm.showBaseForm.orgParentName !== null &&
                              _vm.showBaseForm.orgParentName !== ""
                              ? _vm.showBaseForm.orgParentName
                              : ""
                          )
                        )
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学校办学类型：", prop: "type" } },
                      [
                        _c("span", { staticClass: "form-show-text" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.showBaseForm.type !== undefined &&
                                  _vm.showBaseForm.type !== null &&
                                  _vm.showBaseForm.type !== ""
                                  ? _vm.showBaseForm.type === 1
                                    ? "初中"
                                    : _vm.showBaseForm.type === 2
                                    ? "高中"
                                    : "小学"
                                  : ""
                              )
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学校名称：", prop: "name" } },
                      [
                        _c("span", { staticClass: "form-show-text" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.showBaseForm.name !== undefined &&
                                  _vm.showBaseForm.name !== null &&
                                  _vm.showBaseForm.name !== ""
                                  ? _vm.showBaseForm.name
                                  : ""
                              )
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学制：", prop: "system" } },
                      [
                        _c("span", { staticClass: "form-show-text" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.showBaseForm.system !== undefined &&
                                  _vm.showBaseForm.system !== null &&
                                  _vm.showBaseForm.system !== ""
                                  ? _vm.showBaseForm.system
                                  : ""
                              )
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ul", { staticClass: "query-form mt22" }, [
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c(
          "li",
          [
            _vm.isShow !== true
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.saveSchoolInfo()
                      }
                    }
                  },
                  [_vm._v("保存")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isShow === true
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.showAddForm()
                      }
                    }
                  },
                  [_vm._v("修改")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          class: {
            "add-form": _vm.isShow !== true,
            "show-form": _vm.isShow === true
          },
          attrs: {
            model: _vm.form,
            rules: _vm.formRules,
            "label-width": "186px",
            size: "mini"
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "grid-content bg-purple" }, [
                  _c(
                    "div",
                    { staticStyle: { display: "inline-block" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "min108_8",
                          attrs: { label: "学校地址：", prop: "provinceId" }
                        },
                        [
                          _vm.isShow !== true
                            ? _c(
                                "el-select",
                                {
                                  attrs: {
                                    name: "provinceId",
                                    filterable: "",
                                    placeholder: "请选择省/市",
                                    disabled: _vm.isShow
                                  },
                                  model: {
                                    value: _vm.provinceIndex,
                                    callback: function($$v) {
                                      _vm.provinceIndex =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "provinceIndex"
                                  }
                                },
                                _vm._l(_vm.directoryData.DC0033, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.itemName,
                                      value: index
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShow === true
                            ? _c("span", { staticClass: "form-show-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.convertText(
                                      _vm.directoryData.DC0033,
                                      _vm.provinceIndex,
                                      1
                                    )
                                  )
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { display: "inline-block" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "min108_9",
                          attrs: {
                            label: "",
                            prop: "cityId",
                            "label-width": "0"
                          }
                        },
                        [
                          _vm.isShow !== true
                            ? _c(
                                "el-select",
                                {
                                  attrs: {
                                    name: "cityId",
                                    filterable: "",
                                    placeholder: "请选择市/区",
                                    disabled: _vm.isShow
                                  },
                                  model: {
                                    value: _vm.cityIndex,
                                    callback: function($$v) {
                                      _vm.cityIndex =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "cityIndex"
                                  }
                                },
                                _vm._l(_vm.cityOptions, function(item, index) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.itemName,
                                      value: index
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShow === true
                            ? _c("span", { staticClass: "form-show-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.convertText(
                                      _vm.cityOptions,
                                      _vm.cityIndex,
                                      1
                                    )
                                  )
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { display: "inline-block" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "min108_0",
                          attrs: {
                            label: "",
                            prop: "countyId",
                            "label-width": "0"
                          }
                        },
                        [
                          _vm.isShow !== true
                            ? _c(
                                "el-select",
                                {
                                  attrs: {
                                    name: "countyId",
                                    filterable: "",
                                    placeholder: "请选择区/县",
                                    disabled: _vm.isShow
                                  },
                                  model: {
                                    value: _vm.countyIndex,
                                    callback: function($$v) {
                                      _vm.countyIndex =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "countyIndex"
                                  }
                                },
                                _vm._l(_vm.countyOptions, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.itemName,
                                      value: index
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShow === true
                            ? _c("span", { staticClass: "form-show-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.convertText(
                                      _vm.countyOptions,
                                      _vm.countyIndex,
                                      1
                                    )
                                  )
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "校长姓名：", prop: "principalName" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入校长姓名",
                                disabled: _vm.isShow,
                                maxlength: 50
                              },
                              model: {
                                value: _vm.form.principalName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "principalName",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.principalName"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.principalName !== undefined &&
                                    _vm.form.principalName !== null &&
                                    _vm.form.principalName !== ""
                                    ? _vm.form.principalName
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "address" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入详细地址",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.address,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "address",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.address"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.address !== undefined &&
                                    _vm.form.address !== null &&
                                    _vm.form.address !== ""
                                    ? _vm.form.address
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "党委负责人号：",
                          prop: "partyCommitteeLeaderNumber"
                        }
                      },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入党委负责人号",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.partyCommitteeLeaderNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "partyCommitteeLeaderNumber",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.partyCommitteeLeaderNumber"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.partyCommitteeLeaderNumber !==
                                    undefined &&
                                    _vm.form.partyCommitteeLeaderNumber !==
                                      null &&
                                    _vm.form.partyCommitteeLeaderNumber !== ""
                                    ? _vm.form.partyCommitteeLeaderNumber
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "描述：", prop: "description" } },
                    [
                      _vm.isShow !== true
                        ? _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入描述",
                              disabled: _vm.isShow,
                              maxlength: 200
                            },
                            model: {
                              value: _vm.form.description,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShow === true
                        ? _c("span", { staticClass: "form-show-textarea" }, [
                            _vm._v(
                              _vm._s(
                                _vm.form.description !== undefined &&
                                  _vm.form.description !== null &&
                                  _vm.form.description !== ""
                                  ? _vm.form.description
                                  : ""
                              )
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "组织机构：",
                                  prop: "organization"
                                }
                              },
                              [
                                _vm.isShow !== true
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入组织机构",
                                        disabled: _vm.isShow,
                                        maxlength: 40
                                      },
                                      model: {
                                        value: _vm.form.organization,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "organization",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "form.organization"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isShow === true
                                  ? _c(
                                      "span",
                                      { staticClass: "form-show-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.form.organization !==
                                              undefined &&
                                              _vm.form.organization !== null &&
                                              _vm.form.organization !== ""
                                              ? _vm.form.organization
                                              : ""
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "联系电话：", prop: "phone" } },
                              [
                                _vm.isShow !== true
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入联系电话",
                                        disabled: _vm.isShow,
                                        maxlength: 40
                                      },
                                      model: {
                                        value: _vm.form.phone,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "phone",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "form.phone"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isShow === true
                                  ? _c(
                                      "span",
                                      { staticClass: "form-show-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.form.phone !== undefined &&
                                              _vm.form.phone !== null &&
                                              _vm.form.phone !== ""
                                              ? _vm.form.phone
                                              : ""
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "传真电话：", prop: "fax" } },
                              [
                                _vm.isShow !== true
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入传真电话",
                                        disabled: _vm.isShow,
                                        maxlength: 40
                                      },
                                      model: {
                                        value: _vm.form.fax,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "fax",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "form.fax"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isShow === true
                                  ? _c(
                                      "span",
                                      { staticClass: "form-show-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.form.fax !== undefined &&
                                              _vm.form.fax !== null &&
                                              _vm.form.fax !== ""
                                              ? _vm.form.fax
                                              : ""
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学校代码：", prop: "schoolCode" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入学校代码",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.schoolCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "schoolCode", $$v)
                                },
                                expression: "form.schoolCode"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.schoolCode !== undefined &&
                                    _vm.form.schoolCode !== null &&
                                    _vm.form.schoolCode !== ""
                                    ? _vm.form.schoolCode
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "电子邮箱：", prop: "email" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入电子邮箱",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "email", $$v)
                                },
                                expression: "form.email"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.email !== undefined &&
                                    _vm.form.email !== null &&
                                    _vm.form.email !== ""
                                    ? _vm.form.email
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "学校英文名称：", prop: "englishName" }
                      },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入学校英文名称",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.englishName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "englishName", $$v)
                                },
                                expression: "form.englishName"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.englishName !== undefined &&
                                    _vm.form.englishName !== null &&
                                    _vm.form.englishName !== ""
                                    ? _vm.form.englishName
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "主页地址：", prop: "homePage" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入主页地址",
                                disabled: _vm.isShow,
                                maxlength: 200
                              },
                              model: {
                                value: _vm.form.homePage,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "homePage",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.homePage"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.homePage !== undefined &&
                                    _vm.form.homePage !== null &&
                                    _vm.form.homePage !== ""
                                    ? _vm.form.homePage
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "邮政编码：", prop: "postalCode" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入邮政编码",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.postalCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "postalCode", $$v)
                                },
                                expression: "form.postalCode"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.postalCode !== undefined &&
                                    _vm.form.postalCode !== null &&
                                    _vm.form.postalCode !== ""
                                    ? _vm.form.postalCode
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "历史沿革：",
                          prop: "historicalEvolution"
                        }
                      },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入历史沿革",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.historicalEvolution,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "historicalEvolution", $$v)
                                },
                                expression: "form.historicalEvolution"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.historicalEvolution !== undefined &&
                                    _vm.form.historicalEvolution !== null &&
                                    _vm.form.historicalEvolution !== ""
                                    ? _vm.form.historicalEvolution
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "行政区域码：", prop: "areaCode" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入行政区域码",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.areaCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "areaCode", $$v)
                                },
                                expression: "form.areaCode"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.areaCode !== undefined &&
                                    _vm.form.areaCode !== null &&
                                    _vm.form.areaCode !== ""
                                    ? _vm.form.areaCode
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "所在城乡类型：", prop: "areaType" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入所在城乡类型",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.areaType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "areaType", $$v)
                                },
                                expression: "form.areaType"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.areaType !== undefined &&
                                    _vm.form.areaType !== null &&
                                    _vm.form.areaType !== ""
                                    ? _vm.form.areaType
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "建校年月：", prop: "schoolYears" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-date-picker", {
                              attrs: {
                                type: "month",
                                placeholder: "请选择建校年月",
                                disabled: _vm.isShow,
                                "value-format": "yyyy-MM"
                              },
                              model: {
                                value: _vm.form.schoolYears,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "schoolYears",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.schoolYears"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.schoolYears !== undefined &&
                                    _vm.form.schoolYears !== null &&
                                    _vm.form.schoolYears !== ""
                                    ? _vm.form.schoolYears
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "所在地经济属性",
                          prop: "localEconomic"
                        }
                      },
                      [
                        _vm.isShow !== true
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  name: "localEconomic",
                                  placeholder: "请选择所在地经济属性",
                                  disabled: _vm.isShow
                                },
                                model: {
                                  value: _vm.form.localEconomic,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "localEconomic", $$v)
                                  },
                                  expression: "form.localEconomic"
                                }
                              },
                              _vm._l(_vm.directoryData.DC0005, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.itemName,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.convertText(
                                    _vm.directoryData.DC0005,
                                    _vm.form.localEconomic,
                                    2
                                  )
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "校庆日：", prop: "decorationDay" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-date-picker", {
                              attrs: {
                                type: "date",
                                placeholder: "请选择校庆日",
                                disabled: _vm.isShow,
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.form.decorationDay,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "decorationDay",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.decorationDay"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.decorationDay !== undefined &&
                                    _vm.form.decorationDay !== null &&
                                    _vm.form.decorationDay !== ""
                                    ? _vm.form.decorationDay
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "所在地民族属性：",
                          prop: "nationalProperty"
                        }
                      },
                      [
                        _vm.isShow !== true
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  name: "nationalProperty",
                                  placeholder: "请选择所在地民族属性",
                                  disabled: _vm.isShow
                                },
                                model: {
                                  value: _vm.form.nationalProperty,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nationalProperty", $$v)
                                  },
                                  expression: "form.nationalProperty"
                                }
                              },
                              _vm._l(_vm.directoryData.DC0006, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.itemName,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.convertText(
                                    _vm.directoryData.DC0006,
                                    _vm.form.nationalProperty,
                                    2
                                  )
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "法定代表人号：",
                          prop: "legalRepresentativeNumber"
                        }
                      },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入法定代表人号",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.legalRepresentativeNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "legalRepresentativeNumber",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.legalRepresentativeNumber"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.legalRepresentativeNumber !==
                                    undefined &&
                                    _vm.form.legalRepresentativeNumber !==
                                      null &&
                                    _vm.form.legalRepresentativeNumber !== ""
                                    ? _vm.form.legalRepresentativeNumber
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "主教学语言码：",
                          prop: "mainTeachingLanguage"
                        }
                      },
                      [
                        _vm.isShow !== true
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  name: "mainTeachingLanguage",
                                  placeholder: "请选择主教学语言码",
                                  disabled: _vm.isShow
                                },
                                model: {
                                  value: _vm.form.mainTeachingLanguage,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "mainTeachingLanguage",
                                      $$v
                                    )
                                  },
                                  expression: "form.mainTeachingLanguage"
                                }
                              },
                              _vm._l(_vm.directoryData.DC0007, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.itemName,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.convertText(
                                    _vm.directoryData.DC0007,
                                    _vm.form.mainTeachingLanguage,
                                    2
                                  )
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "法人证书号：",
                          prop: "legalPersonCertificateNo"
                        }
                      },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入法人证书号",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.legalPersonCertificateNo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "legalPersonCertificateNo",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.legalPersonCertificateNo"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.legalPersonCertificateNo !==
                                    undefined &&
                                    _vm.form.legalPersonCertificateNo !==
                                      null &&
                                    _vm.form.legalPersonCertificateNo !== ""
                                    ? _vm.form.legalPersonCertificateNo
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "辅教学语言码：",
                          prop: "auxiliaryLanguage"
                        }
                      },
                      [
                        _vm.isShow !== true
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  name: "auxiliaryLanguage",
                                  placeholder: "请选择辅教学语言码",
                                  disabled: _vm.isShow
                                },
                                model: {
                                  value: _vm.form.auxiliaryLanguage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "auxiliaryLanguage", $$v)
                                  },
                                  expression: "form.auxiliaryLanguage"
                                }
                              },
                              _vm._l(_vm.directoryData.DC0007, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.itemName,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.convertText(
                                    _vm.directoryData.DC0007,
                                    _vm.form.auxiliaryLanguage,
                                    2
                                  )
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "校长工号：", prop: "principalCode" } },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入校长工号",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.principalCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "principalCode",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.principalCode"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.principalCode !== undefined &&
                                    _vm.form.principalCode !== null &&
                                    _vm.form.principalCode !== ""
                                    ? _vm.form.principalCode
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "招生半径：", prop: "admissionsRadius" }
                      },
                      [
                        _vm.isShow !== true
                          ? _c("el-input", {
                              attrs: {
                                placeholder: "请输入招生半径",
                                disabled: _vm.isShow,
                                maxlength: 40
                              },
                              model: {
                                value: _vm.form.admissionsRadius,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "admissionsRadius", $$v)
                                },
                                expression: "form.admissionsRadius"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShow === true
                          ? _c("span", { staticClass: "form-show-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.admissionsRadius !== undefined &&
                                    _vm.form.admissionsRadius !== null &&
                                    _vm.form.admissionsRadius !== ""
                                    ? _vm.form.admissionsRadius
                                    : ""
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "query-form" }, [
      _c("li", { staticClass: "query-input" }, [
        _c("span", { staticClass: "tag_border" }, [_vm._v("学校基本信息")])
      ]),
      _vm._v(" "),
      _c("li", [_vm._v(" ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "query-input" }, [
      _c("span", { staticClass: "tag_border" }, [_vm._v("学校扩展信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", { staticClass: "warning-remark" }, [
        _c("i", { staticClass: "el-icon-warning" }),
        _vm._v("以下信息为选填信息，为了更好的为您提供服务，邀请您填写。")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }